<template>
    <div id="wrefinement" class="search-widget">
        <h3 class="ttl">検索結果の絞り込み</h3>
        <div class="wrefinement-alert-container" v-if="hits > allMaxHits">
            ヒット件数が多すぎるため表示できません。
        </div>
        <div class="wrefinement-container" v-else>
            <Facet
                :title="facetCatyear.facetName"
                :facetdata="facetCatyear.facetResults"
                :showFacetCancel="facetCatyear.showFacetCancel"
                :listMaxSize="allMaxHits"
                :nowHits="hits"
                :firstFacetData="form.catyear"
                :facetError="facetCatyear.facetError"
                :facetLoading="facetCatyear.facetLoading"
                @emittedFacetChange="changeFacetCondition"
                @emittedFacetItems="updateCatyear"
            />
            <!-- v-model:facetItems="catyear" -->
            <Facet
                :title="facetDatabase.facetName"
                :facetdata="facetDatabase.facetResults"
                :showFacetCancel="facetDatabase.showFacetCancel"
                :listMaxSize="otherMaxHits"
                :nowHits="hits"
                :firstFacetData="form.dbname"
                :facetError="facetDatabase.facetError"
                :facetLoading="facetDatabase.facetLoading"
                @emittedFacetChange="changeFacetCondition"
                @emittedFacetItems="updateDBname"
            />
            <!-- v-model:facetItems="dbname" -->
        </div>
    </div>
</template>

<script>
import Facet from "../Facet.vue";

import { SearchKey } from "../../composables/useAllSearch.js";

import { defineComponent, inject, onBeforeMount } from "vue";

export default defineComponent({
    name: "AllFacetContainer",
    components: {
        Facet,
    },
    setup() {
        // *****************
        // Inject
        // *****************
        const {
            facetDatabase,
            facetCatyear,
            getDatabaseFacetList,
            getCatyearFacetList,
            search,
            formRef,
            showFacetCancel,
            hits,
            facetResetFlg,
        } = inject(SearchKey);
        let { form, page } = inject(SearchKey);

        let allMaxHits = 10000;
        let otherMaxHits = 1000;

        // Facet内に表示するデータを取得し、セットする。
        onBeforeMount(async () => {
            /* Facetのデータを取得する */
            if (hits.value < allMaxHits) {
                getCatyearFacetList();
            } else {
                facetCatyear.facetError = false;
            }
            if (hits.value < otherMaxHits) {
                getDatabaseFacetList();
            } else {
                facetDatabase.facetError = false;
            }
        });

        /* Facet操作による検索機能 */
        // 検索実行
        const execSearch = async () => {
            // ページ番号を1に設定する
            page.value = 1;
            facetResetFlg.value = false;
            if (form.value.dbname.length > 0) {
                facetDatabase.showFacetCancel = true;
            } else {
                facetDatabase.showFacetCancel = false;
            }
            if (form.value.catyear.length > 0) {
                facetCatyear.showFacetCancel = true;
            } else {
                facetCatyear.showFacetCancel = false;
            }
            await search();
        };
        const updateSearchResult = () => {
            formRef.value.validate((valid) => {
                if (valid) {
                    execSearch();
                } else {
                    return false;
                }
            });
        };

        // Facetの絞り込み条件が変更されたらFacetデータを更新するため再検索を実行する
        const changeFacetCondition = (...args) => {
            const facetType = args[0];
            const searchCondition = args[1];
            const showFacetCancel = args[2];
            // Facetの絞り込み解除ボタンが押下されたら、絞り込み条件を解除する
            if (facetType === "dbname") {
                form.value.dbname = searchCondition;
                if (showFacetCancel === false) {
                    form.value.dbname = [];
                }
            }
            if (facetType === "catyear") {
                form.value.catyear = searchCondition;
                if (showFacetCancel === false) {
                    form.value.catyear = [];
                }
            }
            // Facetの絞り込みがされたら、絞り込み条件でしぼられたFacetを表示する
            getDatabaseFacetList();
            getCatyearFacetList();
            updateSearchResult();
        };

        const updateDBname = (val) => {
            form.value.dbname = val;
        };
        const updateCatyear = (val) => {
            form.value.catyear = val;
        };

        return {
            facetDatabase,
            facetCatyear,
            changeFacetCondition,
            form,
            updateDBname,
            updateCatyear,
            showFacetCancel,
            hits,
            allMaxHits,
            otherMaxHits,
        };
    },
});
</script>

<style scoped>
#wrefinement {
    margin-top: 5px;
    margin-left: 5px;
}
#wrefinement > .ttl {
    color: #333333;
    font-weight: bold;
    font-size: 121.42%;
    padding-left: 26px;
    margin-bottom: 10px;
    background: url("../../../../../public/images/icon_wrefinement.png")
        no-repeat 0 0;
}
.wrefinement-container {
    background-color: #edf1f1;
}
</style>
